import { TimeFormat } from 'src/models/UIConfiguration'

export const PARAGRAPH_TIMESTAMP_UNKNOWN_PRESENTATION = '--:--'

type TimeFormatDescriptor = {
    momentFormat: string
    containerWidthEm: number
}
export const TIME_FORMAT_DESCRIPTORS: Record<TimeFormat, TimeFormatDescriptor> = {
    '12h': {
        momentFormat: 'hh:mm A',
        containerWidthEm: 4.75,
    },
    '24h': {
        momentFormat: 'HH:mm',
        containerWidthEm: 3,
    },
}
